module.exports = __webpack_public_path__ + "images/category_lp/watch/case4_6386e79bb84efe43f546c146c648c8e1.jpg";